import React from 'react';
import { func, string } from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { translate } from '@fiverr-private/i18n-react';
import {
    selectSellerName, selectSellerOffersHourlyRate,
    useStaticContext
} from '../../../context/contexts/static';
import {
    selectFocusFlag,
    useValidationContext
} from '../../../context/contexts/validation';

import { HOURLY_SUFFIX } from '../constants';
import classes from './style.module.scss';

const Question = ({ className, step, onStepClick = noop }) => {
    const context = useStaticContext();
    const validationContext = useValidationContext();
    const { focusRef } = selectFocusFlag(validationContext);
    const sellerName = selectSellerName(context);
    const sellerOffersHourlyRate = selectSellerOffersHourlyRate(context);
    let translationPrefix = `send_message.quick_questions.${step}`;

    if (sellerOffersHourlyRate && step.endsWith(HOURLY_SUFFIX)) {
        translationPrefix = translationPrefix.substring(0, translationPrefix.length - HOURLY_SUFFIX.length);
    }

    if (step === 'hourly_provide_wd') {
        translationPrefix = 'send_message.quick_questions.hourly_provide';
    }

    const params = { sellerName };
    const formattedMessage = `${translate(`${translationPrefix}.regular`, { params })} `;

    const wrapperClasses = classNames(
        'tbody-5',
        'm-b-12',
        className,
        classes.quickQuestion
    );

    const onClick = () => {
        onStepClick({ step, message: formattedMessage });
        focusRef?.current?.focus();
    };

    return (
        <Button onClick={onClick}
            className={wrapperClasses}
            size={Button.SIZES.SMALL}
            fill={Button.FILLS.GHOST}
            color={Button.COLORS.LIGHT_GREY}>
            {translate(`${translationPrefix}.ellipsis`, { params })}
        </Button>
    );
};

Question.propTypes = {
    className: string,
    step: string.isRequired,
    onStepClick: func
};

export default Question;
